export default "__VITE_ASSET__afbf4684__"